import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../sections/createSendProductReport/message/fieldDefinition";


import { FormlyView } from "../FormlyView";

export class SubstanceInternationalCode extends FormlyView {

    constructor(
        fieldDefinition: FieldDefinition
    ) {
        super(new FormGroup({}), 
            [...fieldDefinition.substanceInternationalCodeFields], {});
    }
}